'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_AppRouter$CuisinesAppPage$() {
}
export { $c_Lmealorama_AppRouter$CuisinesAppPage$ as $c_Lmealorama_AppRouter$CuisinesAppPage$ };
$p = $c_Lmealorama_AppRouter$CuisinesAppPage$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_AppRouter$CuisinesAppPage$;
/** @constructor */
function $h_Lmealorama_AppRouter$CuisinesAppPage$() {
}
export { $h_Lmealorama_AppRouter$CuisinesAppPage$ as $h_Lmealorama_AppRouter$CuisinesAppPage$ };
$h_Lmealorama_AppRouter$CuisinesAppPage$.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return 1841019265;
});
$p.m = (function() {
  return "CuisinesAppPage";
});
$p.q = (function() {
  return 0;
});
$p.r = (function() {
  return "CuisinesAppPage";
});
$p.g = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
var $d_Lmealorama_AppRouter$CuisinesAppPage$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_AppRouter$CuisinesAppPage$, "mealorama.AppRouter$CuisinesAppPage$", ({
  Fo: 1,
  au: 1,
  b: 1,
  c: 1,
  a: 1,
  d: 1,
  e: 1,
  h: 1
}));
export { $d_Lmealorama_AppRouter$CuisinesAppPage$ as $d_Lmealorama_AppRouter$CuisinesAppPage$ };
var $n_Lmealorama_AppRouter$CuisinesAppPage$;
function $m_Lmealorama_AppRouter$CuisinesAppPage$() {
  if ((!$n_Lmealorama_AppRouter$CuisinesAppPage$)) {
    $n_Lmealorama_AppRouter$CuisinesAppPage$ = new $c_Lmealorama_AppRouter$CuisinesAppPage$();
  }
  return $n_Lmealorama_AppRouter$CuisinesAppPage$;
}
export { $m_Lmealorama_AppRouter$CuisinesAppPage$ as $m_Lmealorama_AppRouter$CuisinesAppPage$ };
//# sourceMappingURL=mealorama.-App-Router$-Cuisines-App-Page$.js.map
